const keywords = [
  'abstract',
  'assert',
  'boolean',
  'break',
  'byte',
  'case',
  'catch',
  'char',
  'class',
  'const',
  'continue',
  'default',
  'do',
  'double',
  'else',
  'enum',
  'extends',
  'final',
  'finally',
  'float',
  'for',
  'goto',
  'if',
  'implements',
  'import',
  'instanceof',
  'int',
  'interface',
  'long',
  'native',
  'new',
  'package',
  'private',
  'protected',
  'public',
  'return',
  'short',
  'static',
  'strictfp',
  'super',
  'switch',
  'synchronized',
  'this',
  'throw',
  'throws',
  'transient',
  'try',
  'void',
  'volatile',
  'while',
  'true',
  'false',
  'null',
  '@Override',
  'main'
]

const classes = [
  'ArrayDeque',
  'ArrayIndexOutOfBoundsException',
  'ArrayList',
  'Arrays',
  'BigDecimal',
  'BigInteger',
  'BitSet',
  'Boolean',
  'BufferedInputStream',
  'BufferedOutputStream',
  'BufferedReader',
  'BufferedWriter',
  'Byte',
  'Calendar',
  'Character',
  'Class',
  'ClassCastException',
  'ClassNotFoundException',
  'ClassCastException',
  'ConcurrentModificationException',
  'DateFormat',
  'DataInputStream',
  'DataOutputStream',
  'Date',
  'Deque',
  'Dictionary',
  'Double',
  'Enumeration',
  'Exception',
  'File',
  'FileInputStream',
  'FileNotFoundException',
  'FileOutputStream',
  'FileReader',
  'FileWriter',
  'Float',
  'HashMap',
  'HashSet',
  'Hashtable',
  'IOException',
  'InputStream',
  'InputStreamReader',
  'Integer',
  'Iterable',
  'Iterator',
  'LinkedList',
  'List',
  'Long',
  'Map',
  'Math',
  'NullPointerException',
  'Number',
  'NumberFormatException',
  'ObjectInputStream',
  'ObjectOutputStream',
  'OutputStream',
  'OutputStreamWriter',
  'Pattern',
  'PrintStream',
  'PrintWriter',
  'Properties',
  'Queue',
  'Random',
  'RandomAccessFile',
  'Reader',
  'RuntimeException',
  'Scanner',
  'Set',
  'Short',
  'SimpleDateFormat',
  'Stack',
  'String',
  'StringBuilder',
  'StringBuffer',
  'System',
  'Thread',
  'Throwable',
  'TreeMap',
  'TreeSet',
  'URI',
  'URL',
  'URLConnection',
  'UnsupportedOperationException',
  'UUID',
  'Vector',
  'WeakHashMap',
  'Writer'
]

const fields = [
  'in',
  'out',
  'length',
  'MAX_VALUE',
  'MIN_VALUE',
  'PI',
  'VERSION',
  'SIZE',
  'TRUE',
  'FALSE',
  'NULL',
  'NaN',
  'POSITIVE_INFINITY',
  'NEGATIVE_INFINITY',
  'BYTES',
  'BITS',
  'CASE_INSENSITIVE_ORDER'
]

const functions = [
  'abs()',
  'acos()',
  'add()',
  'addAll()',
  'after()',
  'asin()',
  'before()',
  'charAt()',
  'clear()',
  'clone()',
  'close()',
  'compareTo()',
  'concat()',
  'contains()',
  'containsKey()',
  'containsValue()',
  'cos()',
  'equals()',
  'endsWith()',
  'exp()',
  'execute()',
  'floor()',
  'format()',
  'get()',
  'getTime()',
  'hashCode()',
  'indexOf()',
  'isEmpty()',
  'join()',
  'length()',
  'log()',
  'max()',
  'min()',
  'next()',
  'nextInt()',
  'nextLine()',
  'offer()',
  'openStream()',
  'parse()',
  'parseInt()',
  'pop()',
  'peek()',
  'poll()',
  'pow()',
  'println()',
  'push()',
  'put()',
  'random()',
  'read()',
  'remove()',
  'reverse()',
  'set()',
  'setTime()',
  'shuffle()',
  'size()',
  'sleep()',
  'sort()',
  'split()',
  'sqrt()',
  'startsWith()',
  'substring()',
  'tan()',
  'toDegrees()',
  'toRadians()',
  'toString()',
  'toUpperCase()',
  'trim()',
  'valueOf()',
  'write()'
]
export default {
  keywords,
  classes,
  fields,
  functions
}
